import React, { useState } from 'react';
import { User, TestAttempt } from '../../types/models';
import './StudentStats.css';

type StudentStatsProps = {
  students: User[];
  attempts: TestAttempt[];
};

export const StudentStats = ({ students, attempts }: StudentStatsProps) => {
  const [expandedStudentId, setExpandedStudentId] = useState<string | null>(null);

  const getStatsForStudent = (studentId: string) => {
    const studentAttempts = attempts.filter(att => att.userId === studentId);
    const totalTests = studentAttempts.length;
    const totalCorrectAnswers = studentAttempts.reduce((sum, att) => sum + att.score, 0);
    const totalQuestionsAnswered = studentAttempts.reduce((sum, att) => sum + att.totalQuestions, 0);
    const averageScore = totalQuestionsAnswered > 0 ? ((totalCorrectAnswers / totalQuestionsAnswered) * 100).toFixed(1) : '0';

    return {
      totalTests,
      averageScore,
      studentAttempts
    };
  };

  const toggleDetails = (studentId: string) => {
    setExpandedStudentId(prevId => (prevId === studentId ? null : studentId));
  };
  
  if (students.length === 0) {
      return (
        <div className="stats-container">
            <h3>Statystyki Kursantów</h3>
            <p>Nie znaleziono żadnych kursantów w systemie.</p>
        </div>
      )
  }

  return (
    <div className="stats-container">
      <h3>Statystyki Kursantów</h3>
      <table className="stats-table">
        <thead>
          <tr>
            <th>Kursant</th>
            <th>Liczba testów</th>
            <th>Średnia poprawność</th>
            <th>Szczegóły</th>
          </tr>
        </thead>
        <tbody>
          {students.map(student => {
            const stats = getStatsForStudent(student.id);
            return (
              <React.Fragment key={student.id}>
                <tr>
                  <td>{student.firstName} {student.lastName}</td>
                  <td>{stats.totalTests}</td>
                  <td>{stats.averageScore}%</td>
                  <td>
                    <button onClick={() => toggleDetails(student.id)} disabled={stats.totalTests === 0}>
                      {expandedStudentId === student.id ? 'Ukryj' : 'Pokaż'}
                    </button>
                  </td>
                </tr>
                {expandedStudentId === student.id && (
                  <tr className="details-row">
                    <td colSpan={4}>
                      <div className="details-content">
                        <h4>Historia prób dla {student.firstName}:</h4>
                        <ul>
                          {stats.studentAttempts.map(att => (
                            <li key={att.id}>
                              {new Date(att.dateCompleted).toLocaleDateString('pl-PL')}: 
                              <strong> {att.testSetName}</strong> - 
                              Wynik: {att.score}/{att.totalQuestions}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};